export enum ShortUrlTableDataTypes {
  PARTNER_REFERRAL = 'partner-referral',
  CUSTOMER_REFERRAL = 'customer-referral',
}
